import React from 'react'
import Logout from '../components/auth/Logout'
import Center from '../components/Center'
import { auth } from "../config/firebase";
import MicrophoneSelector from '../components/MicrophoneSelector';
import SmartCubeSelector from '../components/SmartCubeSelector';
import CubeController from '../components/CubeController';

const Profile = () => {
  return (
    <Center height="85vh">
        <div>{auth.currentUser?.displayName}</div>
        <MicrophoneSelector/>
        {/* <CubeController/> */}
        <Logout />

    </Center>
  )
}

export default Profile